import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Title } from "../Title/Title";
import * as styles from "./banner.module.scss";

interface Props {
  active?: boolean;
}

const text1 = "Book today at no risk";
const text2 = "Limited number of seats";

const Elem = () => (
  <div className={styles.elemContainer}>
    <FontAwesomeIcon icon={faExclamationTriangle} className={styles.icon} />
    <Title text={text1} className={styles.warning2} />
    <FontAwesomeIcon icon={faExclamationTriangle} className={styles.icon} />
    <Title text={text2} className={styles.warning} />
  </div>
);

export const Banner: React.FC<Props> = ({ active }) => {
  return (
    <div className={styles.banner}>
      <div className={styles.anim}>
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
        <Elem />
      </div>
    </div>
  );
};
